import { Dock } from 'lucide-react';
import { useEffect, useRef, useState } from "react";
import { NotificationSound } from '../../CommonComponents/CommonNotification';
import { ApiCall } from '../../CommonComponents/CustomHooks';
import { initializeFilterData, virtualPath } from '../../CommonComponents/EnvConfig';
import { Table } from '../../CommonComponents/Table';

const PendingFollowUpLead = () => {
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });

    //--Get Data Function--//
    const GetFollowUpData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/LeadEntry/ShowPendingFollowUpLeadEntry`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res);
        } else if (res.Status === 'ERROR') {
            setTableData([]);
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        GetFollowUpData(value);
    };

    const handleFollowUp = (value, item) => {
        window.open(`${virtualPath}/LeadEntry/LeadEntryFollowUp?LeadNo=${value}`, "_blank");
    }

    //--handle Sorting--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    useEffect(() => {
        document.title = 'Pending Follow Up Lead'
        GetFollowUpData()
    }, [sortConfig]);

    return (
        <>
            <div className='bg-white rounded-lg shadow-sm p-2 mb-6'>
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <Dock className="w-6 h-6 text-teal-600" />
                        <h2 className="text-xl font-semibold text-gray-800">Pending Follow Up Lead</h2>
                    </div>
                </div>
                <div className='card-body pb-1'>
                    <Table
                        loading={isLoading}
                        PageName={'PendingFollowUpLead'}
                        handleFilter={() => {
                            GetFollowUpData(1)
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={tableData}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                        handleFollowUp={handleFollowUp}
                    />

                </div>

            </div>

        </>
    )
}
export default PendingFollowUpLead;